export { A as ARG_SHIFT, I as InternalComponentCapabilities, I as InternalComponentCapability, a as MACHINE_MASK, M as MAX_SIZE, O as OPERAND_LEN_MASK, b as TYPE_MASK, T as TYPE_SIZE } from '../../shared-chunks/flags-BsZlvEeR.js';
export { c as $fp, a as $pc, b as $ra, $ as $s0, h as $s1, d as $sp, g as $t0, f as $t1, e as $v0, i as isLowLevelRegister } from '../../shared-chunks/registers-ylirb0dq.js';

const ContentType = {
  Component: 0,
  Helper: 1,
  String: 2,
  Empty: 3,
  SafeString: 4,
  Fragment: 5,
  Node: 6,
  Other: 8
};

export { ContentType };
